

import React from 'react';

import {Upload, Button,Modal } from '@jd/find-react';
import { Layout,Input,Select,Radio,Form, Cascader} from 'element-react';
 
 

import KeeVue from '../base/KeeVue.js'

 

import $ from 'jquery';
 
import { ExclamationCircleOutlined } from '@ant-design/icons';
 


export default class FsBuildTemplate   extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				randId: this.getRandString(),
				activeRightTab: 'r3',
				keeVueComponents: [],
				appPages: [],
				activePageList: [],
				formField: null,
				newPageIds: [],
				formTypes: [],
				downloadPath: '',
				downloadName: '',
				appId: window.appId,
				isShowExport: false,
				initSelectPageCode: '',
				
				appOptions:[],
				templatePages:[],
				selectApp:'',
			};

}

componentDidMount(){
			var that = this; 
			
			this.doRequest("/jdccApp/getOptions?search_EQ_clientType=TEMPLATE",(ret)=>{
				if(ret) 
				{
					this.state.appOptions = ret;
					
					if(ret!=null&&ret.length>0)
					{
						this.state.selectApp=ret[0].value;
					}
					
					this.showTemplagePages(this.state.selectApp);
					
					this.refresh();
					
				}
			})
		}
		
		  
			
			changed=()=> {}
			valueChange=(item)=> {}
			
			// 返回一个系统字段，增加两个报表字段，做一个模板页面，这里面的都不能修改；
			getForm0=()=>{ }
			
			getTable0=()=>{ }
			
			// 加载应用的所有页面
			loadKeePageList=()=> { }
			initKeePage=(page, formField)=> { }
			selectItem=(item)=> {
				if(item.targetUrl ) {}
			}
			
			showTemplagePages=(appId)=>{
				
				if(appId)
				{
					this.doRequest("/keePage/listData?search_EQ_appId="+appId+"&fields=id,code,config,title",(ret)=>{
						
						this.state.templatePages = ret.rows;
						
						for(let i=0;i<ret.rows.length;i++)
						{
							 
						    ret.rows[i].config = JSON.parse(ret.rows[i].config);
							 
						}
						
						this.refresh();
						
						// 再查询一下页面的详细信息
						// this.doRequest("/keePage/listData?search_EQ_appId="+appId+"&fields=id,config",(ret2)=>{
							
						// 	for(let i=0;i<ret.rows.length;i++)
						// 	{
						// 		for(let j=0;j<ret2.rows.length;j++)
						// 		{
						// 			if(ret.rows[i].id==ret2.rows[j].id)
						// 			{
						// 				ret.rows[i].config = JSON.parse(ret2.rows[j].config);
						// 			}
						// 		}
						// 	}
							
						// 	this.refresh();
						// });
						
						
						
					})
				}
				
			}
			
			onCreatePage=(item)=>{
				
				 Modal.confirm({
				    title: 'Confirm',
				    icon: <ExclamationCircleOutlined />,
				    content: "是否通过模板："+item.title+"("+item.code+")创建新页面",
				    okText: '确认',
				    cancelText: '取消',
					onOk:()=>{
						this.sendEvent("createNewPageByPage",item.id);
					}
				  });
				  
				
				// Dialog.confirm({
				//                 content: "是否通过模板："+item.title+"("+item.code+")创建新页面",
				//                 onConfirm: async () => {
				                  
				// 				  this.sendEvent("createNewPageByPage",item.id);
								  
				//                 },
				// 				onCancel:async()=>{
									 
				// 				}
				//               }); 
							  
				
				
			}

			renderItem=(item,index)=>{
 
			}

  render(){
  return(

<div className={`jdcc-disable-select`} id={this.state.randId} >
    <div style={{position:' absolute', top:' 0px', bottom:' 0', right:' 0', width:' 100%'}} >
        <div style={{position:' absolute',left:' 0',top:' 4px',right:' 0px',bottom:' 0px',overflow:' auto', padding:'8px'}} boxid="fs-build-right-pages" >
            <div >
                <div style={{width:' 100%'}} className={`fsComponentProperty`} >
                    <div style={{padding:' 5px', textAlign:'right'}} >
                         
                    </div> 
                    模板管理页面
				   <Select style={{'width':'100%'}} type="primary"
				    value={this.state.selectApp}
				   	allowClear={false}
				   	onChange={(sv)=>{
						this.showTemplagePages(sv);
				   	this.refresh();}}  >
				   	{
				   		this.state.appOptions.map((item,index)=>{
				   		 return <Select.Option  
				   		 key={item.value} label={item.title} value={item.value} >{item.title} </Select.Option>
				   	  })
				   	 }
				   </Select>
                </div>
               
                <div style={{paddingLeft:'0px',marginTop:'15px'}}  >
                    
					{
						this.state.templatePages.map((item,index)=>{
						 return <div key={item.id} className={`build-template-item`} onClick={()=>{this.onCreatePage(item)  }}>
						 
						 <div className={`build-template-item-title`} >{item.title}
						 </div>
						 <div className={`build-template-item-code`}>{item.code}</div>
						 <div style={{'textAlign':'center','padding':'10px'}}> 
							{ item.config&&item.config.postImg?<img src={window.fileUrl+"/api/fs/getById?ids="+item.config.postImg}  />:<img src="./img/noimg.jpg"  />} 
						 </div>
						 
						 </div>  
						 
					  })
					 }
					 
                </div>
            </div>
        </div>
    </div>
</div>
  );}
 }
